import * as React from "react";
import { SVGProps } from "react";
function SvgPlayIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 5.81v8.38c0 .638.687 1.025 1.213.683l6.421-4.19a.82.82 0 0 0 0-1.364L7.213 5.128C6.687 4.785 6 5.172 6 5.81Z"
        fill="#16A085"
      />
    </svg>
  );
}
export default SvgPlayIcon;
